import * as React from 'react';
import * as main from '../../main.module.scss';
import * as program from './style.module.scss';
import gallery from './gallery.json';
import { CarouselFullscreen } from '../../../../CarouselFullscreen';
const Slides = ({ day }) => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return gallery.map(
    (elem, index) =>
      day === elem.day && (
        <div className={program.slides} key={index}>
          <h5>
            Посмотрите слайды
            <br /> презентации этого урока:
          </h5>
          <div className={program.slidesList}>
            {elem.slidesPreviews.map((e, i) => (
              <button
                key={i}
                aria-label={`button-${i}`}
                onClick={() => {
                  setFullScreenState({ open: true, selectedSlideIndex: i });
                }}
              >
                <img src={e} alt="" />
              </button>
            ))}
          </div>
          <CarouselFullscreen
            data={elem.slidesBig.map((e) => (
              <img src={e} alt="" style={{ maxHeight: '80vh' }} />
            ))}
            open={fullScreenState.open}
            selectedSlideIndex={fullScreenState.selectedSlideIndex}
            onClose={() => {
              setFullScreenState({ open: false, selectedSlideIndex: 0 });
            }}
          />
        </div>
      )
  );
};
const Gallery = ({ day }) => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return gallery.map(
    (elem, index) =>
      day === elem.day && (
        <div className={program.gallery} key={index}>
          {elem.screensPreviews.map((e, i) => (
            <button
              className={program.screenBtn}
              key={i}
              aria-label={`button-${i}`}
              onClick={() => {
                setFullScreenState({ open: true, selectedSlideIndex: i });
              }}
            >
              <img src={e} alt="" />
            </button>
          ))}
          <Slides day={day} />

          <CarouselFullscreen
            data={elem.screensBig.map((e) => (
              <img src={e} alt="" style={{ maxHeight: '80vh' }} />
            ))}
            open={fullScreenState.open}
            selectedSlideIndex={fullScreenState.selectedSlideIndex}
            onClose={() => {
              setFullScreenState({ open: false, selectedSlideIndex: 0 });
            }}
          />
        </div>
      )
  );
};
export const Program = () => {
  return (
    <section className={program.program}>
      <div className="container">
        <h2 className={main.title}>Программа марафона</h2>
        <p className={main.subtitle}>5 дней, которые изменят ваше будущее</p>
        <ul className={program.mainList}>
          <li>
            <a href="#tt">
              <h3>
                <span>День 1</span> Что такое развитие мозга.
                <br /> Что и как в нем можно развивать, а что нет?
              </h3>
            </a>
            <div className={program.infoWrap}>
              <Gallery day={1} />
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.time}>1 час 25 минут</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Почему тренировку мозга нужно начинать именно с памяти</li>
                  <li>Как запоминать много, точно и надолго без зубрежки</li>
                  <li>Разные типы памяти как фундамент для работы с разными типами информации</li>
                  <li>Интеллектуальная выносливость и как ее повысить</li>
                  <li>Ацетилхолин, нейромедиаторы и принцип «яйца» в обучении</li>
                </ul>
                <div className={program.filesWrap}>
                  <h4>На этом дне вы получите:</h4>
                  <a href="#tt" aria-label={'ссылка на регистрацию'}>
                    <ul className={program.filesList}>
                      <li className={program.day1Globe}>
                        <h5>Онлайн-курс «Глобус на пальце»</h5>
                        <p>Курс для тех, кто хочет знать все страны в мире и их расположение на карте</p>
                      </li>
                      <li className={program.day1Hyerog}>
                        <h5>Запомните 22 китайских иероглифа за 5 минут</h5>
                        <p>и десятки единиц новой информации</p>
                      </li>
                      <li className={program.day1Brain}>
                        <h5>Понимание именно ваших возможностей от тренировки мозга</h5>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат первого дня:</h4>
                <p>
                  Вы узнаете главные принципы тренировки мозга, как можно и как нельзя повысить его эффективность и
                  получите собственный опыт применения мнемотехник для запоминания
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <h3>
                <span>День 2</span> Методики понимания или можно ли развить свой интеллект?
              </h3>
            </a>
            <div className={program.infoWrap}>
              <Gallery day={2} />
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.time}>1 час 25 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Как работает понимание и как его тренировать</li>
                  <li>Роль воображения в понимании нового и сложного</li>
                  <li>Упражнения на тренировку разных способов понимания</li>
                  <li>Чем ум отличается от мудрости и как получить и то и другое</li>
                </ul>
                <div className={program.filesWrap}>
                  <h4>На этом дне вы получите:</h4>
                  <a href="#tt" aria-label={'ссылка на регистрацию'}>
                    <ul className={program.filesList}>
                      <li className={program.day25neuro}>
                        <h5>Мини-курс «5 нейроупражнений»</h5>
                        <p>Разгони свой мозг и забудь об усталости всего за 5 дней с нашими нейротренировками</p>
                      </li>
                      <li className={program.day2Mindmap}>
                        <h5>Опыт работы с майнд-картами</h5>
                      </li>
                      <li className={program.day2Alghorytm}>
                        <h5>Алгоритм понимания любой сложной информации</h5>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат второго дня:</h4>
                <p>
                  Вы на своем опыте убедитесь, что понимать можно по-разному, и получите базовую систему координат для
                  выбора инструментов понимания под ваши задачи
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <h3>
                <span>День 3</span> Скорочтение, скорослушание и эффективное чтение
              </h3>
            </a>
            <div className={program.infoWrap}>
              <Gallery day={3} />
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.time}>1 час 25 минут</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Скорочтение и скорослушание — мифы и факты</li>
                  <li>Как работает мозг в режиме чтения и слушания</li>
                  <li>Как тренировать скорость восприятия информации при чтении и слушании</li>
                  <li>Ошибки, из-за которых скорочтение не работает</li>
                  <li>Упражнения для увеличения скорости чтения и скорости слушания</li>
                  <li>Стратегия чтения – как сделать так, чтобы книги не пылились на полках, а меняли жизнь!</li>
                </ul>
                <div className={program.filesWrap}>
                  <h4>На этом дне вы получите:</h4>
                  <a href="#tt" aria-label={'ссылка на регистрацию'}>
                    <ul className={program.filesList}>
                      <li className={program.day3Sledi}>
                        <h5>«Следи за объектом»</h5>
                        <p>Онлайн-игра для развития внимания и памяти</p>
                      </li>
                      <li className={program.day3Read}>
                        <h5>Опыт чтения на скорости вдвое выше вашей привычной</h5>
                      </li>
                      <li className={program.day3Readspeed}>
                        <h5>Три упражнения для развития скорости чтения</h5>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат третьего дня:</h4>
                <p>
                  Вы убедитесь, что скорочтение работает, если тренировать его правильно, а время и силы можно экономить
                  по несколько часов в день!
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <h3>
                <span>День 4</span> Новый язык или новая профессия, есть ли разница?
                <br />
                Знания и навыки и особенности в их получении
              </h3>
            </a>
            <div className={program.infoWrap}>
              <Gallery day={4} />
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.time}>1 час 45 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Почему люди годами учат новый язык и годами осваивают новые профессии безрезультатно</li>
                  <li>Методики быстрого набора лексики в любой сфере или любом языке</li>
                  <li>Мнемотехники</li>
                  <li>Майнд-карты</li>
                  <li>Паттерны</li>
                  <li>Преодоление языкового барьера</li>
                  <li>Методика постановки любого навыка</li>
                </ul>
                <div className={program.filesWrap}>
                  <h4>На этом дне вы получите:</h4>
                  <a href="#tt" aria-label={'ссылка на регистрацию'}>
                    <ul className={program.filesList}>
                      <li className={program.day4Travel}>
                        <h5>Онлайн-курс «100 английских слов для путешествий»</h5>
                        <p>Курс для тех, кто хочет быстро запоминать иностранные слова</p>
                      </li>
                      <li className={program.day4Navik}>
                        <h5>Понимание, как от изучения теории перейти к формированию навыков</h5>
                      </li>
                      <li className={program.day4Metod}>
                        <h5>Две методики для преодоления языкового барьера</h5>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат четвёртого дня:</h4>
                <p>
                  Вы поймете, как сформировать любой навык в любой сфере, не важно будет это профессия, иностранный
                  язык, язык программирования или управление самолетом
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <h3>
                <span>День 5</span> Управление изменениями в жизни через тренировку мозга
              </h3>
            </a>
            <div className={program.infoWrap}>
              <Gallery day={5} />
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.time}>1 час 55 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>
                    Почему умные люди бывают бедными, как этого избежать и как сделать так, чтобы тренировка мозга
                    меняла вашу жизнь
                  </li>
                  <li>
                    Ключевые навыки, которые нужны для заработка денег, помимо высокого интеллекта и умения учиться, и
                    как их освоить
                  </li>
                  <li>Как связаны здоровье и тренировка мозга</li>
                  <li>Взаимосвязь отношений и тренировки мозга</li>
                  <li>
                    Связь гибких навыков (умение общаться, выступать публично, креативность, критическое мышление,
                    умение говорить «нет» и т.д.) и тренировки мозга
                  </li>
                  <li>Хобби и тренировка мозга, разбор разных видов хобби</li>
                  <li>Личная эффективность, тайм менеджмент, и другие навыки успешного человека</li>
                </ul>
                <div className={program.filesWrap}>
                  <h4>На этом дне вы получите:</h4>
                  <a href="#tt" aria-label={'ссылка на регистрацию'}>
                    <ul className={program.filesList}>
                      <li className={program.day5Planning}>
                        <h5>Экспресс-курс по планированию</h5>
                      </li>
                      <li className={program.day5Alghorytm}>
                        <h5>Конкретный алгоритм изменения вашей жизни</h5>
                      </li>
                      <li className={program.day5Koordinat}>
                        <h5>Систему координат и верные точки приложения усилий для управления вашей жизнью</h5>
                      </li>
                    </ul>
                  </a>
                </div>
              </div>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат пятого дня:</h4>
                <p>
                  Вы поймете, как изменить вашу жизнь именно там, где вы сами этого хотите, и составите план таких
                  изменений, который будете реализовывать, а не прокрастинировать
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};
